module.exports = __webpack_public_path__ + "static/media/xmly.c20d4081.svg";